export const warrantTest = [
  {
    title: "Q1.選擇題: 為何影片中媽媽要罵爸爸?",
    subtitle: "(權證懶人包-考試篇 買股票沒買權證 真是太可惜了!)",
    topics: [
      { topicIndex: 1, content: "爸爸很懂股票並且有買權證" },
      { topicIndex: 2, content: "爸爸很懂股票卻不買權證" },
      { topicIndex: 3, content: "爸爸不懂股票卻亂買權證" },
      { topicIndex: 4, content: "爸爸不懂股票且不買權證" },
    ],
    answer: 2,
  },
  {
    title: "Q2. 是非題: 投資權證就像追求理想型，看準機會就要行動。",
    subtitle: "(權證懶人包-撩妹篇 買股票沒買權證 真是太可惜了!)",
    topics: [
      { topicIndex: 1, content: "O" },
      { topicIndex: 2, content: "X" },
    ],
    answer: 1,
  },
  {
    title: "Q3. 選擇題: 買進的權證已經好幾天都沒有報價，會是什麼原因呢？",
    subtitle: "(權證13問：神秘女兒解惑)",
    topics: [
      { topicIndex: 1, content: "權證的價值低於0.01元時" },
      { topicIndex: 2, content: "股票出現漲停或跌停的時候" },
      { topicIndex: 3, content: "不可抗的技術性問題，例如: 券商電腦系統當機" },
      { topicIndex: 4, content: "以上皆是" },
    ],
    answer: 4,
  },
  {
    title: "Q4. 選擇題: 下列哪一項關於權證的敘述不正確?",
    subtitle: "(認購認售好難懂？鳳馨姊五分鐘講明白)",
    topics: [
      { topicIndex: 1, content: "具有特定的有效期間" },
      { topicIndex: 2, content: "權證是以特定價格來買進或賣出標的股票的權利" },
      { topicIndex: 3, content: "履約價就是指該檔權證的價格，也就是權利金 " },
      { topicIndex: 4, content: "認購權證是價格與股價同向的權證" },
      {
        topicIndex: 5,
        content: "如果標的股價的走勢符合預期，投資權證的獲利性高於股票",
      },
    ],
    answer: 3,
  },
  {
    title:
      "Q5. 選擇題: 哪一種金融投資商品，讓小資族只用少少的錢，就能輕鬆獲利翻倍?",
    subtitle: "(我的權證STYLE：旅遊夢)",
    topics: [
      { topicIndex: 1, content: "期貨" },
      { topicIndex: 2, content: "股票" },
      { topicIndex: 3, content: "權證" },
      { topicIndex: 4, content: "基金" },
    ],
    answer: 3,
  },
  {
    title:
      "Q6. 選擇題: 權證是逐筆撮合，以下哪種方式下單，具有即時、快速、精確的特性，也是目前最多人使用的方法呢?",
    subtitle: "(權證上手好Easy：買權證的第一步)",
    topics: [
      { topicIndex: 1, content: "電話下單" },
      { topicIndex: 2, content: "網路下單" },
      { topicIndex: 3, content: "語音下單" },
      { topicIndex: 4, content: "臨櫃下單" },
    ],
    answer: 2,
  },
  {
    title: "Q7.選擇題: 權證具有以下哪個優點?",
    subtitle: "(買股票也買權證，獲利增加)",
    topics: [
      { topicIndex: 1, content: "投資門檻低、交易金額低" },
      { topicIndex: 2, content: "買賣方式簡單，靈活操作" },
      { topicIndex: 3, content: "最大損失有限、槓桿效果大" },
      { topicIndex: 4, content: "以上皆是" },
    ],
    answer: 4,
  },
  {
    title:
      "Q8. 選擇題: 做交易不與趨勢為敵，請問看多股票行情，可用甚麼權證投資?",
    subtitle: "(賴憲政【找對權證，操作心法大公開】)",
    topics: [
      { topicIndex: 1, content: "認售權證" },
      { topicIndex: 2, content: "認購權證" },
      { topicIndex: 3, content: "都可以" },
    ],
    answer: 2,
  },
  {
    title: "Q9. 選擇題:  選定股票之後，權證該怎麼挑?",
    subtitle: "(權證LET'S購：下單前，先選股票，再挑權證)",
    topics: [
      { topicIndex: 1, content: "選最便宜的，不用管條件" },
      {
        topicIndex: 2,
        content: "選價外程度高的，不但價格便宜，而且股票漲一點點權證就會漲很多",
      },
      {
        topicIndex: 3,
        content:
          "強烈看多(空)，選短天期價外權證；普通看多(空)，選長天期價平，比較漲的動",
      },
      {
        topicIndex: 4,
        content:
          "強烈看多(空)，選長天期價平權證，普通看多(空)，選短天期價外，比較漲的動",
      },
    ],
    answer: 3,
  },
  {
    title: "Q10. 選擇題:  權證投資應注意以下何種事項?",
    subtitle: "(權證LET'S購：買入後，嚴設停利停損點，該放手別緊握)",
    topics: [
      { topicIndex: 1, content: "權證投資適合短期操作。" },
      { topicIndex: 2, content: "權證投資具有時間價值減損的壓力" },
      {
        topicIndex: 3,
        content: "若權證投資須嚴守停損紀律，避免其價值擴大流失",
      },
      { topicIndex: 4, content: "以上皆是" },
    ],
    answer: 4,
  },
  {
    title: "Q11. 是非題: 權證有時間價值，請問適合長期投資嗎?",
    subtitle: "(熊市來臨還能投資股票嗎？如何找到投資機會？Ft.權證贏家)",
    topics: [
      { topicIndex: 1, content: "O" },
      { topicIndex: 2, content: "X" },
    ],
    answer: 2,
  },
  {
    title: "Q12. 選擇題: 進場之前，需要注意?",
    subtitle: "(達人專訪2：挑流動性好的權證，深入研究各股產業增加勝率)",
    topics: [
      { topicIndex: 1, content: "多空方向" },
      { topicIndex: 2, content: "執行比例" },
      { topicIndex: 3, content: "天期長短" },
      { topicIndex: 4, content: "以上皆是" },
    ],
    answer: 4,
  },
];
